<template>
    <div class="teacher">
        <Header></Header>
        <div style="width: 100%;overflow: hidden;overflow-y: auto;scrollbar-width: none; " :style="{
            'height': (innerHeight - 70 - 68) + 'px'
        }">
            <div class="teacher_container">
                <div class="teacher_content_left">
                    <div class="teacher_name">{{ teacherInfo.name }}</div>
                    <div class="teacher_text_content">
                        <div style="height: 100%;overflow: auto;">
                            <div class="teacher_tag_list">
                                <div class="teacher_tag" v-for="(item, index) in teacherInfo.tags" :key="index">
                                    {{ item.name }}
                                </div>
                            </div>
                            <div class="teacher_text">
                                {{ teacherInfo.intro }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="teacher_content_right"><img :src="teacherInfo.portraitUrl"></div>
            </div>


            <div style="width: 1500px;overflow: hidden;overflow-y: auto;scrollbar-width: none;margin-bottom: 100px; " :style="{
                'margin-left': innerWidth > 1500 ? (innerWidth - 1500) / 2 + 'px' : '0px'
            }">
                <div style="margin-top: 50px;height: 70px;line-height: 70px;">
                    <div style="" class="container_title fl">推荐课程</div>
                </div>
                <div v-for="(good, i) in goodList" :key="i" >
                    <div class="good fl" @click="goGoodDetail(good.goodsId)" style="width: 250px;padding: 10px;margin-top: 20px;margin-left: 11px;">
                        <el-image style="width: 250px; border-radius: 10px;" :src="good.photos[0].url">
                        </el-image>
                        <div style="min-height: 50px;">
                            <div class="w100p over_2">{{ good.goodsName }}</div>
                            <div style="color: #c8c9cc;height: 50px;line-height: 50px;">
                                <span><i class="el-icon-s-custom" style="font-size: 15px;"></i> {{ good.studyNum
                                    }}人在学</span>
                                <span class="fr cdeeporange">￥{{ (good.minPrice / 100).toFixed(2) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <Suspension></Suspension>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "../../components/common/Header"
import Footer from "../../components/common/Footer"
import Suspension from "../../components/common/Suspension"

import {
    // getByUrl,
    getByParam
} from '@/api/api.js';

export default {
    name: "Teacher",
    data() {
        return {
            teacherInfo: {},
            goodList: [],
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        }
    },
    mounted() {
        console.log(this.$route.query.id);
        this.getTeacherDetails(this.$route.query.id);
        this.getTeacherGoods(this.$route.query.id);
    },
    methods: {
        goGoodDetail(id){
            this.$router.push({
                path: '/good/det',
                query: {
                 id: id
                }
            })
        },
        getTeacherDetails(id) {
            let param = {
                teacherId: id
            }
            getByParam('/web/teacher/detail', param).then(res => {
                console.log(res);
                this.teacherInfo = res.data;
            })
        },
        getTeacherGoods(id) {
            let param = {
                teacherId: id
            }
            getByParam('/web/mall/teacher/goods/list', param).then(res => {
                console.log(res);
                this.goodList = res.data;
            })
        }

    },
    components: {
        Header,
        Footer,
        Suspension
    }
}
</script>

<style scoped>
.container_title {
    font-size: 32px;
    font-weight: 600;
    color: #2B2E33;
}

.teacher_container {
    height: 420px;
    background: #343e65;
    position: relative;
    background-image: url('../../../static/image/teacher/teacher_det_back.png');
    background-size: cover;
}

.teacher_content_left {
    position: absolute;
    left: 8%;
    width: 50%;
    height: 100%;
}


.teacher_name {
    color: #FFF;
    font-weight: 600;
    font-size: 44px;
    line-height: 48px;
    margin: 86px 0 15px;
}

.teacher_text_content {
    height: 139px;
    position: relative;
    overflow: hidden;
}

.teacher_tag_list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
}

.teacher_tag {
    padding: 5px 15px;
    border-radius: 6px;
    background: linear-gradient(90deg, #f7deca, #eec9a1);
    color: #915e37;
    font-size: 12px;
    line-height: 14px;
    flex-shrink: 0;
    margin: 0 15px 10px 0;

}

.teacher_text {
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    color: #fff;
    padding-top: 5px;
    padding-bottom: 10px;
}

.teacher_content_right {
    position: absolute;
    right: 4%;
    width: 38%;
    display: flex;
    justify-content: center;
    z-index: 3;
    height: 100%;
}
</style>